import { findHalfEdgeEntryOrFail } from "../net/findHalfEdgeEntryOrFail.js";
import {} from "../net/index.js";
import { formatPort } from "../port/formatPort.js";
import {} from "../port/index.js";
import {} from "./HalfEdge.js";
export function formatHalfEdge(net, halfEdge) {
    const halfEdgeEntry = findHalfEdgeEntryOrFail(net, halfEdge);
    const port = halfEdgeEntry.port;
    const portText = maybeFormatPort(net, port);
    const otherHalfEdge = halfEdgeEntry.otherHalfEdge;
    const otherHalfEdgeEntry = findHalfEdgeEntryOrFail(net, otherHalfEdge);
    const otherPort = otherHalfEdgeEntry.port;
    const otherPortText = maybeFormatPort(net, otherPort);
    return `#HalfEdge(${portText}, ${otherPortText})`;
}
function maybeFormatPort(net, port) {
    return port === undefined ? `#unconnected` : formatPort(net, port);
}
//# sourceMappingURL=formatHalfEdge.js.map